<template>
  <div>
    <client-secret-modal
      :visible.sync="showSecret"
      :client-id="issued.client_id"
      :client-secret="issued.client_secret"
      @update:visible="onSecretAcknowledged"
    />

    <b-overlay :show="loading" rounded="sm">
      <api-client-form v-model="form" :registry="registry" :disabled="loading" />

      <div class="d-flex justify-content-end">
        <b-button variant="outline-secondary" class="mr-1" :to="{ name: 'api-clients' }">
          Cancel
        </b-button>
        <b-button variant="primary" :disabled="!isValid || loading" @click="onSubmit">
          Create client
        </b-button>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import { get } from 'lodash'
import { BButton, BOverlay } from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

import ApiClientForm from '@core/components/api-clients/ApiClientForm.vue'
import ClientSecretModal from '@core/components/api-clients/ClientSecretModal.vue'

export default {
  components: {
    BButton,
    BOverlay,
    ApiClientForm,
    ClientSecretModal,
  },
  data() {
    return {
      loading: false,
      showSecret: false,

      registry: { resources: [], client_statuses: [] },

      issued: {
        client_id: '',
        client_secret: '',
      },

      form: {
        title: '',
        description: '',
        contact_name: '',
        contact_email: '',
        permissions: [],
        scope_rules: [],
        fixed_fields: [],
        // empty means any address
        allowed_ips: '',
        excluded_fields: [],
        // Profile-only unless an admin deliberately widens it, matching the server default.
        user_provisioning: 'none',
        rate_limit: {
          limit: 3000,
          window_seconds: 60,
        },
        token_ttl_seconds: 3600,
      },
    }
  },
  computed: {
    isValid() {
      return Boolean(
        this.form.title && this.form.contact_name && this.form.contact_email
      )
    },
  },
  created() {
    this.fetchRegistry()
  },
  methods: {
    async fetchRegistry() {
      try {
        this.loading = true
        const request = await this.useJwt().mainService.apiClients.registry()
        this.registry = get(request, 'data.data', { resources: [] })
      } catch (error) {
        const error_message = get(error, 'response.data.message') || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message,
          },
        })
      } finally {
        this.loading = false
      }
    },
    async onSubmit() {
      try {
        this.loading = true

        const request = await this.useJwt().mainService.apiClients.create(this.form)
        const created = get(request, 'data.data', {})

        this.issued = {
          client_id: created.client_id || '',
          client_secret: created.client_secret || '',
        }
        this.showSecret = true
      } catch (error) {
        const error_message = get(error, 'response.data.message') || error.message
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Error!',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
            text: error_message,
          },
        })
      } finally {
        this.loading = false
      }
    },
    onSecretAcknowledged(visible) {
      // Only navigate once the admin has dismissed the one-time secret, so it is never
      // lost to a redirect.
      if (visible === false && this.issued.client_secret) {
        this.$router.push({ name: 'api-clients' }).catch(() => {})
      }
    },
  },
}
</script>
